<template>
    <BreadCrumb PageTitle="Liste des corrections Requests " />
    <ListeCorrectionRequest/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeCorrectionRequest from "@/components/CorrectionRequest/ListeCorrectionRequest.vue";

export default defineComponent({
    name: "ListeCorrectionRequestPage",
    components: {
        BreadCrumb,
        ListeCorrectionRequest,
    },
});
</script>